import { IconClose, IconPin } from 'ui/icons';
import { IconCrossLarge, IconMapMarker } from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { PatronLocationFinderSearchInput } from 'components/patron-location/PatronLocationFinderSearchInput';
import { PatronLocationFinderSearchResults } from 'components/patron-location/PatronLocationFinderSearchResults';
import { searchInputContainer } from 'components/patron-location/patronLocationCssDefs';
import React, { FunctionComponent, useState } from 'react';

export interface PatronLocationFinderSearchSuggestion {
  placeId: string;
  primaryText: string;
  secondaryText: string;
}

interface PatronLocationFinderSearchProps {
  centerLatLng?: google.maps.LatLng;
  handleSuggestion(suggestion: PatronLocationFinderSearchSuggestion): void;
  initialValue?: string;
  sessionToken?: google.maps.places.AutocompleteSessionToken;
}

export const PatronLocationFinderSearch: FunctionComponent<PatronLocationFinderSearchProps> = ({
  centerLatLng,
  handleSuggestion,
  initialValue,
  sessionToken,
}) => {
  const [suggestions, setSuggestions] = useState<PatronLocationFinderSearchSuggestion[]>([]);
  const { focusIndex, setFocusIndex, handleKeyDown } = useFocusToggleIndex(suggestions.length);
  const handleFocus = () => {
    setFocusIndex(-1);
  };

  return (
    <>
      <div css={searchInputContainer}>
        <PatronLocationFinderSearchInput
          centerLatLng={centerLatLng}
          iconClear={<IconMigrationUtil legacyIcon={<IconClose />} newIcon={<IconCrossLarge />} />}
          iconStart={<IconMigrationUtil legacyIcon={<IconPin />} newIcon={<IconMapMarker />} />}
          initialValue={initialValue}
          onInputKeyDown={handleKeyDown}
          onInputFocus={handleFocus}
          selected={focusIndex === -1}
          sessionToken={sessionToken}
          setSuggestions={setSuggestions}
        />
      </div>
      <PatronLocationFinderSearchResults
        onItemKeyDown={handleKeyDown}
        onSuggestion={handleSuggestion}
        selectedIndex={focusIndex}
        setSelectedIndex={setFocusIndex}
        suggestions={suggestions}
      />
    </>
  );
};

const useFocusToggleIndex = (maxIndex: number) => {
  const [focusIndex, setFocusIndex] = useState(-1);
  const handleKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    const index = focusIndex;
    if (event.key === 'Escape' && index > -1) {
      event.preventDefault();
      setFocusIndex(-1);
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      setFocusIndex(Math.min(maxIndex, Math.max(-1, index + direction)));
    }
  };
  return { focusIndex, setFocusIndex, handleKeyDown };
};
